import { UserInfo } from '@types';

export function formatIf(
  data: Record<string, any>,
  condition: (elem: any) => boolean,
  format: (elem: any) => any
) {
  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const elem = data[key];
    if (elem) {
      if (condition(elem)) {
        data[key] = format(elem);
      } else if (elem instanceof Array) {
        data[key] = elem.map((e) => (condition(e) ? format(e) : formatIf(e, condition, format)));
      } else if (elem instanceof Object) {
        data[key] = formatIf(elem, condition, format);
      }
    }
  }
  return data;
}

export type SortDirection = 'asc' | 'desc';

export function sortBy<T, K extends keyof T>(
  vals: T[],
  key: K,
  direction: SortDirection,
  preprocessor?: (val: T[K]) => any
) {
  const sign = direction === 'asc' ? -1 : 1;
  const usePreprocessor = preprocessor ? preprocessor : (val: any) => val;

  return vals.sort((left, right) => {
    const valA = usePreprocessor(left[key]);
    const valB = usePreprocessor(right[key]);

    if (valA > valB) {
      return -1 * sign;
    }

    if (valA < valB) {
      return 1 * sign;
    }

    return 0;
  });
}

export function sortByDisplayName<T extends { displayName: string }>(users: T[]) {
  return sortBy(users, 'displayName', 'asc', (val: string) => (val ? val.toLowerCase() : val));
}

export function filterChatUserInfo(userInfo: UserInfo[], currentUserId: string) {
  const filteredDocs = userInfo.filter((user) => user.userId !== currentUserId);
  if (filteredDocs.length > 0) {
    return filteredDocs;
  } else {
    return userInfo.filter((user) => user.userId === currentUserId);
  }
}

// TODO: Intl not available on Android
// const COMPACT_NUMBER_FORMATTER = Intl.NumberFormat(getLocaleString(), { notation: 'compact' });

export function formatNumber(number: number) {
  // return COMPACT_NUMBER_FORMATTER.format(number);
  return number;
}
